import {
	AiAssistantConfiguration,
	userConfiguration
} from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { useState } from "react";

export function useAiAssistantConfiguration(): AiAssistantConfiguration {
	const [configuration] = useState<AiAssistantConfiguration>(
		(): AiAssistantConfiguration => userConfiguration().aiAssistant
	);

	return configuration;
}
